import React from 'react';
import { MdOutlineDelete } from "react-icons/md";
import { Button } from "../../../components/ui/button";
import { ExternalLink, Trash2, FileText } from "lucide-react";

const ScanList = ({ scans, handleRemoveScan }) => {
  if (scans.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 bg-slate-50/50 rounded-[2rem] border-2 border-dashed border-slate-200">
        <FileText className="w-16 h-16 text-slate-300 mb-4" />
        <p className="text-slate-500 font-medium">No documents uploaded yet</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
      {scans.map((scan, index) => (
        <div 
          key={scan.id} 
          className={`group bg-white border border-slate-100 rounded-3xl p-5 shadow-sm hover:shadow-xl transition-all duration-300 ${scan.isNew ? 'ring-2 ring-teal-500/20' : ''}`}
        >
          <div className="flex justify-between items-start mb-4">
            <div className="space-y-1">
              <span className="text-[10px] uppercase tracking-widest font-black text-slate-400">
                {scan.isNew ? 'New Entry' : 'Stored File'}
              </span>
              <h3 className="font-bold text-slate-800 line-clamp-1">{scan.description}</h3>
            </div>
            {scan.isNew && (
              <button 
                onClick={() => handleRemoveScan(scan.id)}
                className="p-2 text-red-500 hover:bg-red-50 rounded-xl transition-colors"
                title="Discard"
              >
                <Trash2 className="w-5 h-5" />
              </button>
            )}
          </div>

          <div 
            className="relative aspect-video w-full overflow-hidden rounded-2xl bg-slate-100 cursor-pointer group-hover:scale-[1.02] transition-transform duration-500"
            onClick={() => window.open(scan.fileUrl, "_blank")}
          >
            <img
              src={scan.fileUrl}
              alt={scan.description}
              className="w-full h-full object-cover transition-all duration-500 group-hover:blur-[2px]"
            />
            <div className="absolute inset-0 bg-slate-900/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full text-slate-900 font-bold text-sm shadow-xl">
                <ExternalLink className="w-4 h-4" />
                View Fullscreen
              </div>
            </div>
          </div>
          
          <div className="mt-4 flex items-center justify-between text-[11px] font-bold text-slate-400">
            <span>Doc ID: {scan.id.split('-')[1]?.slice(-6) || 'N/A'}</span>
            {!scan.isNew && (
              <span className="bg-emerald-100 text-emerald-700 px-2 py-1 rounded-md">Verified Secure</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScanList;
